import { render, staticRenderFns } from "./ClinicFamilyDic.vue?vue&type=template&id=05b20db8"
import script from "./ClinicFamilyDic.vue?vue&type=script&lang=js"
export * from "./ClinicFamilyDic.vue?vue&type=script&lang=js"
import style0 from "./ClinicFamilyDic.vue?vue&type=style&index=0&id=05b20db8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b20db8')) {
      api.createRecord('05b20db8', component.options)
    } else {
      api.reload('05b20db8', component.options)
    }
    module.hot.accept("./ClinicFamilyDic.vue?vue&type=template&id=05b20db8", function () {
      api.rerender('05b20db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicFamilyDic.vue"
export default component.exports